import Logo from '@/components/Logo';
import { ArrowLeftIcon } from 'lucide-react';

export const NavButton = ({
  onClick,
  icon,
  disabled,
}: {
  onClick: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
}) => {
  return (
    <button
      className={`flex justify-center items-center w-7 h-7 rounded-md p-1.5 ease-in transition-all duration-150 ${
        disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      } ${disabled ? '' : 'hover:bg-popover-hover'}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {icon}
    </button>
  );
};

interface OnboardingHeaderProps {
  onBack?: () => void;
  disabled?: boolean;
  showLogo?: boolean;
}

const OnboardingHeader = ({
  onBack,
  disabled,
  showLogo = true,
}: OnboardingHeaderProps) => {
  return (
    <div className="fixed top-0 flex flex-row justify-between px-6 py-7 w-full">
      <div>
        {onBack && (
          <NavButton
            icon={<ArrowLeftIcon strokeWidth={3} color="#666666" />}
            onClick={onBack}
            disabled={disabled}
          />
        )}
      </div>

      {showLogo && (
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <Logo href="" className="dark:invert max-lg:h-20" />
        </div>
      )}
    </div>
  );
};

export default OnboardingHeader;
